import React from 'react';
function Home() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" })));
}
export default Home;
